import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface Retry extends SVGProps<SVGSVGElement> {
  label?: string
}

const Retry: React.FC<Retry> = ({ label = 'retry', ...restProps }) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        data-testid="alert-svg"
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.333252 7.00016C0.333252 3.31826 3.31802 0.333496 6.99992 0.333496C8.84152 0.333496 10.5098 1.08109 11.7156 2.28775C12.142 2.71447 12.5987 3.24181 12.9999 3.72979V1.66683C12.9999 1.29864 13.2984 1.00016 13.6666 1.00016C14.0348 1.00016 14.3333 1.29864 14.3333 1.66683V5.66683C14.3333 6.03502 14.0348 6.3335 13.6666 6.3335H9.66659C9.2984 6.3335 8.99992 6.03502 8.99992 5.66683C8.99992 5.29864 9.2984 5.00016 9.66659 5.00016H12.3127C11.8512 4.42102 11.2776 3.73573 10.7725 3.23023C9.80648 2.26359 8.47353 1.66683 6.99992 1.66683C4.0544 1.66683 1.66659 4.05464 1.66659 7.00016C1.66659 9.94568 4.0544 12.3335 6.99992 12.3335C9.43041 12.3335 11.4828 10.7072 12.1249 8.482C12.227 8.12824 12.5965 7.92422 12.9502 8.0263C13.304 8.12838 13.508 8.49791 13.4059 8.85166C12.6036 11.6322 10.0402 13.6668 6.99992 13.6668C3.31802 13.6668 0.333252 10.6821 0.333252 7.00016Z"
          fill="white"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default Retry

